var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenaiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50px",
    height: "50px",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 1264 c-234 -50 -436 -254 -485 -489 -95 -454 306 -855 760 -760 181 38 349 168 433 335 95 191 95 389 0 580 -129 257 -422 396 -708 334z m169 -149 c23 -8 56 -26 75 -40 26 -19 45 -25 87 -25 70 -1 124 -26 176 -83 50 -54 67 -109 60 -189 -3 -34 -1 -61 5 -64 23 -14 48 -91 48 -150 0 -107 -66 -201 -166 -234 -19 -6 -34 -17 -34 -24 0 -26 -60 -95 -104 -121 -86 -50 -198 -43 -279 19 -27 20 -46 26 -88 26 -70 1 -124 26 -176 83 -50 54 -67 109 -60 189 3 34 1 61 -5 64 -23 14 -48 91 -48 150 0 106 65 200 163 234 22 8 38 24 52 52 50 102 182 153 294 113z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 1036 c-21 -13 -49 -41 -62 -62 -22 -36 -24 -50 -24 -181 l0 -141 36 -21 c19 -12 37 -21 40 -21 2 0 4 65 4 145 l0 145 105 61 c58 34 105 63 105 65 0 2 -13 10 -30 19 -45 23 -128 19 -174 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708 946 c-180 -95 -168 -85 -168 -139 0 -27 3 -46 8 -44 4 2 60 35 124 71 l117 67 103 -60 c56 -33 106 -57 110 -55 11 7 0 71 -18 105 -27 54 -104 99 -171 99 -12 0 -60 -20 -105 -44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 848 c-32 -34 -62 -94 -62 -125 0 -36 21 -93 46 -122 23 -28 224 -151 246 -151 6 0 26 9 45 21 l34 21 -123 72 -123 71 -3 123 c-3 136 -8 143 -60 90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722 809 l-33 -21 123 -72 123 -71 3 -123 c3 -136 8 -143 60 -89 32 33 62 93 62 124 0 36 -21 93 -46 122 -24 29 -225 151 -247 151 -7 0 -27 -10 -45 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 732 l-48 -27 0 -65 0 -65 50 -28 50 -28 50 28 50 28 0 65 0 65 -49 28 c-27 15 -51 27 -52 27 -2 0 -25 -13 -51 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790 525 l0 -144 -105 -61 c-58 -34 -105 -64 -105 -66 0 -13 67 -34 111 -34 66 0 123 31 155 86 22 38 24 51 24 181 l0 141 -36 21 c-19 12 -37 21 -40 21 -2 0 -4 -65 -4 -145z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613 449 l-123 -70 -102 60 c-56 33 -106 57 -110 55 -11 -7 0 -71 18 -105 31 -61 123 -108 188 -95 17 4 81 34 143 69 l113 62 0 48 c0 26 -1 47 -2 47 -2 0 -58 -32 -125 -71z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenaiIcon);
export default __webpack_public_path__ + "static/media/openai-icon.03c771ec06fcd0189c786fc2e5427beb.svg";
export { ForwardRef as ReactComponent };